import { IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { IsNotEmpty } from 'class-validator';
import { action, makeAutoObservable, observable } from 'mobx';
import { toast } from 'react-toastify';
import { inject } from 'tsyringe';

import type { IPegasusIOGateway } from '@/shared/application/interfaces/pegasus-io.gateway';
import { IsStrongPassword, Match, ObservableForm } from '@/shared/presentation/forms/BaseForm';

class ChangePasswordForm {
  @IsNotEmpty({ message: 'Campo obrigatório' })
  currentPassword = '';

  @IsStrongPassword()
  newPassword = '';

  @Match((p) => p.newPassword, { message: 'As senhas não coincidem' })
  newPasswordConfirmation = '';
}

@ViewModel()
export class ChangePasswordViewModel implements IReactiveModel {
  @observable form = new ObservableForm(ChangePasswordForm);
  @observable isSubmitting = false;

  constructor(@inject('IPegasusIOGateway') private pegasusIOGateway: IPegasusIOGateway) {
    makeAutoObservable(this);
  }

  @action
  async onInit() {}

  async update() {
    try {
      if (this.form.hasError) {
        return;
      }

      this.isSubmitting = true;

      await this.pegasusIOGateway.changePassword({
        currentPassword: this.form.values.currentPassword,
        newPassword: this.form.values.newPassword,
      });

      this.form.reset();

      toast.success('Senha atualizada com sucesso');
    } catch (error) {
      console.error(error);
      toast.error('Erro ao atualizar senha');
    } finally {
      this.isSubmitting = false;
    }
  }
}
